import { getJstTimestamp } from "@/components/utils/dateUtils";
import type { CouponListItem } from "@/resources/coupon";
import { createCsvContent, downloadCsv } from "./csvUtils";

/**
 * Downloads coupon list as CSV file
 * @param coupons Array of coupon items to be exported
 * @returns {void}
 */
export function downloadCouponListAsCsv(coupons: CouponListItem[]) {
  const headers = [
    "CouponCode",
    "Password",
    "Ticket Registration",
    "User Display Name",
  ];
  const rows = coupons.map((coupon) => [
    coupon.couponCode,
    coupon.password,
    coupon.isConfirmed ? "completed" : "incomplete",
    coupon.displayName,
  ]);

  const csvContent = createCsvContent(rows, headers);
  downloadCsv(csvContent, `couponList_${getJstTimestamp()}.csv`);
}

export function downloadNoDialogAssessmentCsv() {
  const content = "No Results";
  const filename = `exportData_${getJstTimestamp()}.csv`;
  downloadCsv(content, filename);
}

export function downloadSampleCouponCsv() {
  const rows = [
    ["ticketId0", "password0"],
    ["ticketId1", "password1"],
    ["ticketId2", "password2"],
    ["ticketId3", "password3"],
    ["ticketId4", "password4"],
  ];
  const csvContent = createCsvContent(rows);
  downloadCsv(csvContent, "ticket-sample.csv");
}
